module.exports = __webpack_public_path__ + "img/golf_cos3.e0bd7259.png";